module.exports = __webpack_public_path__ + "img/thumbnail_ArcticFox_j_normal.68b64a7f.png";